import shortly from 'vuex-shortly'
import {
  ACCOUNT, ACCOUNTS, ACCOUNT_BLOCKED_PARTNERS, ACCOUNT_BLOCKED_PARTNERS_, ACCOUNT_BLOCKED_PARTNERS_DISABLE,
  ACCOUNT_BLOCKED_PARTNERS_PAGINATE, ACCOUNT_CLEAR_ID, ACCOUNT_SEARCH, ACCOUNT_BLOCKED_PARTNERS_ENABLE,
  ACCOUNTS_WITH_EMAIL_PERMISSION, ACCOUNT_DELETE_PERMISSION, NOTIFICATIONS_INCLUDE, VIDALINK_ACCOUNTS
} from '@store/types'
import axios from 'axios'
import graphQL from '@graphQL'
import AccountsQuery from '@graphQL/queries/Accounts'
import AccountsWithEmailPermissionQuery from '@graphQL/queries/AccountsWithEmailPermission'
import AccountsWithoutEmailPermissionQuery from '@graphQL/queries/AccountsWithoutEmailPermission'
import PartnersQuery from '@graphQL/queries/Partners'

const state = {
  account: {},
  accounts: [],
  vidalink_accounts: [],
  blockedPartners: [],
  paginate: {},
  categories: []
}

const getters = {
  [ACCOUNTS]: 'accounts',
  [VIDALINK_ACCOUNTS]: 'vidalink_accounts',
  [ACCOUNT_BLOCKED_PARTNERS_]: 'blockedPartners',
  [ACCOUNT_BLOCKED_PARTNERS_PAGINATE]: 'paginate'
}

const mutations = {
  [ACCOUNTS]: (state, { data }) => (state.accounts = data),

  [ACCOUNT_CLEAR_ID]: (state) => {
    state.account.id = ''
  },

  [ACCOUNT_BLOCKED_PARTNERS_]: 'blockedPartners',

  [ACCOUNT_BLOCKED_PARTNERS_PAGINATE]: 'paginate',

  [ACCOUNT_SEARCH]: (state, payload) => {
    const managers = [...state.account.managers, payload]

    state.account = { ...state.account, managers }
  }
}

const actions = {
  [ACCOUNTS]: async ({ commit }, params) => {
    const response = await graphQL(AccountsQuery, params)
    const { accounts } = response.data.data || {}

    commit(ACCOUNTS, accounts || {})
    return accounts
  },

  [VIDALINK_ACCOUNTS]: async ({ commit }) => {
    const response = await graphQL(AccountsQuery, { vidalink: true })
    const { accounts } = response.data.data || {}

    commit(VIDALINK_ACCOUNTS, accounts || {})
    return accounts
  },

  [ACCOUNTS_WITH_EMAIL_PERMISSION]: async ({ commit }, params) => {
    let response = {}
    if (params.toManager) response = await graphQL(AccountsWithoutEmailPermissionQuery, params)
    else response = await graphQL(AccountsWithEmailPermissionQuery, params)
    const { accounts } = response.data.data || {}
    return accounts.data
  },

  [ACCOUNT_CLEAR_ID]: async ({ commit }) => {
    commit(ACCOUNT_CLEAR_ID)
  },

  [ACCOUNT_SEARCH]: async ({ dispatch, state }, { id, payload }) => {
    try {
      const { data: { success } } = await axios.post(`/company/${id}/role`, payload)

      const notification = {
        type: success ? 'success' : 'error',
        message: success
          ? 'Gestor adicionado com sucesso!'
          : 'Houve um erro ao adicionar o gestor.'
      }
      dispatch(NOTIFICATIONS_INCLUDE, notification)

      if (success) {
        dispatch(ACCOUNT, {
          id,
          includeDetails: true,
          includeEdit: true,
          includeManagers: true,
          includeBlocked: true,
          getConfig: true
        })
      }
    } catch (e) {
      dispatch(NOTIFICATIONS_INCLUDE, new Error('Já existe um gestor com esse cpf'))
    }
  },

  [ACCOUNT_DELETE_PERMISSION]: async ({ dispatch }, { id, document }) => {
    try {
      const { data: { success } } = await axios.post(`/company/${id}/role`, { ...document, '_method': 'DELETE' })

      const notification = {
        type: success ? 'success' : 'error',
        message: success
          ? 'Gestor removido com sucesso!'
          : 'Houve um erro ao remover o gestor.'
      }
      dispatch(NOTIFICATIONS_INCLUDE, notification)

      if (success) {
        dispatch(ACCOUNT, {
          id,
          includeDetails: true,
          includeEdit: true,
          includeManagers: true,
          includeBlocked: true,
          getConfig: true
        })
      }
    } catch (e) {
      dispatch(NOTIFICATIONS_INCLUDE, new Error('Houve um erro ao remover o gestor.'))
    }
  },

  [ACCOUNT_BLOCKED_PARTNERS]: async ({ state, dispatch }, payload) => {
    try {
      const response = await axios.post(`company/${state.account.id}/block-partners`, payload)

      if (response.data.success) {
        dispatch(ACCOUNT, {
          id: state.account.id,
          includeDetails: true,
          includeEdit: true,
          includeBlocked: true
        })

        dispatch(NOTIFICATIONS_INCLUDE, {
          type: 'success',
          message: 'Parceiros bloqueados alterados com sucesso!'
        })
      } else {
        dispatch(NOTIFICATIONS_INCLUDE, new Error('Não foi possível alterar os parceiros bloqueados.'))
      }

      return response.data.success
    } catch (e) {
      dispatch(NOTIFICATIONS_INCLUDE, new Error('Não foi possível alterar os parceiros bloqueados.'))
      return false
    }
  },

  [ACCOUNT_BLOCKED_PARTNERS_]: async ({ commit }, payload = {}) => {
    const response = await graphQL(PartnersQuery, payload)
    const { data: partners, ...paginate } = response?.data?.data?.partners || {}

    commit(ACCOUNT_BLOCKED_PARTNERS_, partners)
    commit(ACCOUNT_BLOCKED_PARTNERS_PAGINATE, paginate)
  },

  [ACCOUNT_BLOCKED_PARTNERS_ENABLE]: async ({ dispatch }, payload) => {
    const perks = payload.map((perk) => perk.id)

    await axios.patch('/perks/group', {
      status: 1,
      ids: perks
    })

    await dispatch(ACCOUNT_BLOCKED_PARTNERS_)
  },

  [ACCOUNT_BLOCKED_PARTNERS_DISABLE]: async ({ dispatch }, payload) => {
    const perks = payload.map((perk) => perk.id)

    await axios.patch('/perks/group', {
      status: 0,
      ids: perks
    })

    await dispatch(ACCOUNT_BLOCKED_PARTNERS_)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/accounts.js